export const imgPath = {
  odometerWideGrey: "/assets/img/odometer-80-wide-grey.png",
  odometerGrey: "/assets/img/odometer-80-grey.png",
  fleetGrey: "/assets/img/fleets-80-grey.png",
  speedOdometer: "/assets/img/speedometer.png",
  date: "/assets/img/dateandtime.png",
  location: "/assets/img/location.png",
  journey: "/assets/img/journey.png",

  refreshRed: "/assets/img/refresh-red.png",
  refreshGreen: "/assets/img/refresh-green.png",

  licensePlate: "/assets/img/licence-plate.png",
  licensePlateYellow: "/assets/img/licence-plate-yellow.png",
  licensePlateGreen: "/assets/img/licence-plate-green.png",
  licensePlateRed: "/assets/img/licence-plate-red.png",

  ignitionOn: "/assets/img/key.png",
  ignitionOff: "/assets/img/key-off.png",
  ignitionStationary: "/assets/img/key-pending.png",

  addWeight: "/assets/img/add-weight.png",

  speedmetor: "/assets/img/speedometer.png",
  stopSign: "/assets/img/stop-sign.png",
};

export const fileType = {
  pdf: "pdf",
  csv: "csv"
};

export const dataOrderAs = {
  ASC: "ASC",
  DESC: "DESC"
};


export const offroadClaimDataOrder = {
  ClaimNumber: "ClaimNumber",
  ClaimDate: "ClaimDate",
  CreateBy: "CreateBy",
  ClaimDistance: "ClaimDistance",
  ClaimStatus: "ClaimStatus"
};



export const offroadClaimDetailDataOrder = {
  Id: "Id",
  RucLicenseNumber: "RucLicenseNumber",
  RucLicenseStartDistance: "RucLicenseStartDistance",
  RucLicenseEndDistance: "RucLicenseEndDistance",
  OffroadDistance: "OffroadDistance",
  OffroadReasonName: "OffroadReasonName"
};

export const offroadDataOrder = {
  RucLicenseId: "RucLicenseId",
  VehiclePlate: "VehiclePlate",
  VehicleCode: "VehicleCode",
  RucLicenseNumber: "RucLicenseNumber",
  RucLicensePurchaseDate: "RucLicensePurchaseDate",
  RucLicenceType: "RucLicenceType",
  RucLicenseStartDistance: "RucLicenseStartDistance",
  RucLicenseEndDistance: "RucLicenseEndDistance",
  OffroadDistance: "OffroadDistance",
  OffroadReturnValue: "OffroadReturnValue",
  IsValid: "IsValid"
};


export const userDataOrder = {
  UserId: "UserId",
  UserCode: "UserCode",
  FirstName: "FirstName",
  UserActive: "UserActive",
  RoleId: "RoleId"
};


export const geoBoundaryDataOrder = {
  GeoBoundaryId: "GeoBoundaryId",
  GeoBoundaryName: "GeoBoundaryName",
  Address: "Address",
};



export const offroadReason = [
  { Name: "Dairy Supply", Value: "DairySupply" },
  { Name: "Sheep Beef", Value: "SheepBeef" },
  { Name: "Horticulture", Value: "Horticulture" },
  { Name: "Other Agriculture", Value: "OtherAgriculture" },
  { Name: "Minning Quarrying", Value: "MinningQuarrying" },
  { Name: "Manufacturing", Value: "Manufacturing" },
  { Name: "Construction", Value: "Construction" },
  { Name: "Wholesale Retail Trade", Value: "WholesaleRetailTrade" },
  { Name: "Scheduled Road Passenger", Value: "ScheduledRoadPassenger" },
  { Name: "Other Road Passenger Transport", Value: "ConstructionOtherRoadPassengerTransport" },
  { Name: "Forestry Logging", Value: "ForestryLogging" },
  { Name: "Stock Haulage", Value: "StockHaulage" },
  { Name: "Refrigerated Haulage", Value: "RefrigeratedHaulage" },
  { Name: "Furniture Removal", Value: "FurnitureRemoval" },
  { Name: "General Freightline Haulage", Value: "GeneralFreightlineHaulage" },
  { Name: "Govt, Local Body, Community", Value: "Govt" },
  { Name: "Private Transport", Value: "PrivateTransport" },
  { Name: "Trade Truck Dealers", Value: "TradeTruckDealers" },
  { Name: "Hubo Replaced", Value: "HuboReplaced" },

];